import { getAuthTokens } from '@/storage/auth-tokens.storage';
import { removeLegacyRegistrationStorage } from '@/storage/legacy-registration.storage';
import { authStore, resolveAuthenticatedUser } from '@/store/auth.store';
import { getLogger } from '@/logger/logger';
import { registerSessionExpiryHandler } from '@/utils/auth/session-expiry.util';

const logger = getLogger('auth.init');

export async function initializeAuth(): Promise<void> {
  removeLegacyRegistrationStorage();
  registerSessionExpiryHandler();

  const tokens = getAuthTokens();

  if (!tokens?.access_token) {
    logger.info('Session initialization finished', {
      auth: { event: 'session_initialized', outcome: 'no_token' },
    });
    authStore.setState({ authStatus: 'unauthenticated' });
    return;
  }

  authStore.setState({ authStatus: 'loading' });

  try {
    await resolveAuthenticatedUser(tokens.access_token);
    const state = authStore.getState();
    if (state.authenticatedUser) {
      logger.info('Session initialization finished', {
        auth: { event: 'session_initialized', outcome: 'authenticated' },
      });
    } else {
      logger.warn('Session initialization finished', {
        auth: { event: 'session_initialized', outcome: 'no_user_returned' },
      });
      authStore.setState({ authStatus: 'unauthenticated' });
    }
  } catch (error) {
    logger.error('Session initialization finished', {
      auth: { event: 'session_initialized', outcome: 'failed' },
      error,
    });
    authStore.setState({ authStatus: 'unauthenticated' });
  }
}
